/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {CreditApproval} from './credit-approval.model';

export class CustomerCreditDto extends JSONable {
  approvalStatus: string | undefined = undefined;
  billingCycle: string | undefined = undefined;
  checkValidityDays: number | undefined = undefined;
  creditLimit: number | undefined = undefined;
  currencyValue: string | undefined = undefined;
  customerUuid: string | undefined = undefined;
  expectedYearlyRevenue: number | undefined = undefined;
  paymentMethod: string | undefined = undefined;
  paymentTerms: string | undefined = undefined;
  creditStatus: string | undefined = undefined;
  uuid: string | undefined = undefined;
  version: number | undefined = undefined;
  requestComment: string | undefined = undefined;
  requestDate: string | undefined = undefined;
  requestTime: string | undefined = undefined;
  approval: CreditApproval | undefined = undefined;

  constructor() {
    super();
  }
}
